import React from 'react';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { RankChart } from '../RankChart';

const IncidentReportSection = ({ data, topCameraData, topGatewayData }) => {
  const { t } = useTranslation();

  if (!data?.cameraDisconnectionEvent && !data?.gatewayDisconnectionEvent) {
    return null;
  }

  return (
    <div>
      <div className="section-title">{t('INCIDENT STATISTICS')}</div>
      <Row gutter={8} style={{ marginTop: 10 }}>
        <Col span={12} style={{ alignSelf: 'stretch' }}>
          <div
            className="content-center chart-item"
            style={{ height: '100%' }}
          >
            <div className="chart-title">{t('Top cameras disconnected')}</div>
            <RankChart color="#FFC94A" data={topCameraData} />
          </div>
        </Col>
        <Col span={12}>
          <div className="content-center chart-item">
            <div className="chart-title">{t('Top gateways disconnected')}</div>
            <RankChart color="#FFC94A" data={topGatewayData} />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default IncidentReportSection;
